import PropTypes from "prop-types"
import React from "react"
import { fillCopy } from "src/main/Billing/PayInvoices/copy"

import Form from "src/components/Form"

const CardReaderProcessing = ({
  isCollecting,
  cardReaders,
  cardReaderId,
  errorMessage,
  copy,
}) => {
  const cardReaderName = cardReaders.find(
    (cardReader) => String(cardReader.id) === String(cardReaderId)
  )?.displayName

  return (
    <div className="flex flex-col items-center gap-3 py-8 text-center">
      {isCollecting ? (
        <>
          <i className="fa-kit fa-internet-wireless animate-pulse text-3xl text-blue-500" />
          <p className="m-0 text-base font-semibold">
            {cardReaderName
              ? fillCopy(copy.waitingOnReader, { name: cardReaderName })
              : copy.waiting}
          </p>
          <p className="text-muted m-0">{copy.presentCard}</p>
        </>
      ) : (
        <p className="m-0 text-base font-semibold">{copy.stillProcessing}</p>
      )}
      {errorMessage ? <Form.Error>{errorMessage}</Form.Error> : null}
    </div>
  )
}

CardReaderProcessing.propTypes = {
  isCollecting: PropTypes.bool.isRequired,
  cardReaders: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      displayName: PropTypes.string,
    })
  ).isRequired,
  cardReaderId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  errorMessage: PropTypes.string,
  copy: PropTypes.shape({
    presentCard: PropTypes.string.isRequired,
    stillProcessing: PropTypes.string.isRequired,
    waiting: PropTypes.string.isRequired,
    waitingOnReader: PropTypes.string.isRequired,
  }).isRequired,
}

export default CardReaderProcessing
